import {
  collection,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  setDoc,
} from "firebase/firestore";
import { app } from "../util/firebase";
const db = getFirestore(app);

export default class Common {
  static createToWallets = async (walletAddress, walletType) => {
    console.log(walletAddress, walletType);
    const docData = {
      is_default: false,
      is_linked: false,
      wallet_address: walletAddress,
      wallet_blockchain: "CARDANO",
      wallet_type: walletType.toUpperCase(),
    };
    await setDoc(doc(db, "wallets", walletAddress), docData);
    console.log("here");
  };

  static getPathToOpen = async () => {
    const cribConfigDocRef = doc(db, process.env.REACT_APP_COLLECTION_CONFIG);
    const docSnap = await getDoc(cribConfigDocRef);
    if (docSnap?.data()?.metaverse_url) {
      return `${
        docSnap?.data()?.metaverse_url
      }?access_token=${localStorage.getItem(
        "access_token"
      )}&refresh_token=${localStorage.getItem("refresh_token")}`;
    } else {
      return null;
    }
  };
}


